import Vue from 'vue';
import { Component } from 'vue-property-decorator';

@Component
class MHReceptionDetailHeader extends Vue {


  
  /**
   *
   */
  constructor() {
    super();

  }



  mounted() {
  }

}

export default MHReceptionDetailHeader;



// WEBPACK FOOTER //
// ./src/containers/mh-reception/components/mh-reception-detail-header/index.ts